export default "__VITE_ASSET__Cc4$mlxI__"